(() => {
  const body = document.body;
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartItems = document.querySelector('[data-cart-items]');
  const cartEmpty = document.querySelector('[data-cart-empty]');
  const siteOverlay = document.querySelector('[data-site-overlay]');

  const getFocusable = (container) =>
    container?.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

  const openPanel = (panel) => {
    if (!panel) return;
    document.querySelectorAll('.is-open[data-overlay-panel]').forEach((open) => {
      if (open !== panel) closePanel(open);
    });
    panel.removeAttribute('hidden');
    panel.setAttribute('aria-hidden', 'false');
    body.classList.add('kz-overlay-open');
    siteOverlay?.classList.add('is-open');
    window.requestAnimationFrame(() => panel.classList.add('is-open'));
    getFocusable(panel)?.focus();
  };

  const closePanel = (panel) => {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => {
      panel.setAttribute('hidden', '');
      if (!document.querySelector('.is-open[data-overlay-panel]')) {
        body.classList.remove('kz-overlay-open');
        siteOverlay?.classList.remove('is-open');
      }
    }, 320);
  };

  const formatMoney = (cents, currency = 'USD') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format(cents / 100);
    } catch (_error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const setCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
      element.hidden = count < 1;
    });
  };

  const cartLine = (item, index, currency) => {
    const article = document.createElement('article');
    article.className = 'kz-cart-line';

    if (item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.product_title || '';
      image.loading = 'lazy';
      article.appendChild(image);
    }

    const details = document.createElement('div');
    details.className = 'kz-cart-line__details';

    const title = document.createElement('a');
    title.href = item.url;
    title.className = 'kz-cart-line__title';
    title.textContent = item.product_title;
    details.appendChild(title);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      const variant = document.createElement('p');
      variant.className = 'kz-cart-line__variant';
      variant.textContent = item.variant_title;
      details.appendChild(variant);
    }

    const meta = document.createElement('div');
    meta.className = 'kz-cart-line__meta';

    const quantity = document.createElement('span');
    quantity.textContent = `Qty ${item.quantity}`;
    meta.appendChild(quantity);

    const price = document.createElement('strong');
    price.textContent = formatMoney(item.final_line_price, currency);
    meta.appendChild(price);
    details.appendChild(meta);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'kz-cart-line__remove';
    remove.dataset.removeLine = String(index + 1);
    remove.textContent = 'Remove';
    details.appendChild(remove);

    article.appendChild(details);
    return article;
  };

  const renderCart = (cart) => {
    setCartCount(cart.item_count);
    document.querySelectorAll('[data-cart-total]').forEach((element) => {
      element.textContent = formatMoney(cart.total_price, cart.currency);
    });

    if (!cartItems) return;
    cartItems.replaceChildren();
    if (cart.item_count < 1 && cartEmpty) cartItems.appendChild(cartEmpty);
    cart.items.forEach((item, index) => cartItems.appendChild(cartLine(item, index, cart.currency)));
    if (cartEmpty) cartEmpty.hidden = cart.item_count > 0;
    cartItems.hidden = cart.item_count < 1;
  };

  const fetchCart = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Unable to load cart.');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const showFormStatus = (form, message, isError = false) => {
    let status = form.querySelector('[data-form-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.formStatus = '';
      status.className = 'kz-form-status';
      form.appendChild(status);
    }
    status.textContent = message;
    status.classList.toggle('is-error', isError);
  };

  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-site-overlay]')) {
      document.querySelectorAll('.is-open[data-overlay-panel]').forEach(closePanel);
      return;
    }

    const openButton = event.target.closest('[data-open-panel]');
    if (openButton) {
      const panel = document.querySelector(openButton.dataset.openPanel);
      if (panel?.matches('[data-cart-drawer]')) {
        try {
          await fetchCart();
        } catch (_error) {
          // The cart page remains available if the drawer request fails.
        }
      }
      openPanel(panel);
      return;
    }

    const closeButton = event.target.closest('[data-close-panel]');
    if (closeButton) {
      closePanel(closeButton.closest('[data-overlay-panel]'));
      return;
    }

    const overlay = event.target.closest('[data-overlay-panel]');
    if (overlay && event.target === overlay) {
      closePanel(overlay);
      return;
    }

    const removeButton = event.target.closest('[data-remove-line]');
    if (removeButton) {
      removeButton.disabled = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(removeButton.dataset.removeLine), quantity: 0 }),
        });
        if (!response.ok) throw new Error('Unable to remove item.');
        renderCart(await response.json());
      } catch (_error) {
        removeButton.disabled = false;
      }
      return;
    }

    if (event.target.closest('[data-cart-checkout]')) {
      window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.kz-quick-add, .kz-product-form');
    if (!form) return;
    event.preventDefault();

    const submit = form.querySelector('[type="submit"]');
    const originalLabel = submit?.textContent;
    if (submit) {
      submit.disabled = true;
      submit.textContent = 'Addingâ€¦';
    }

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Unable to add this item.');
      }
      await fetchCart();
      openPanel(cartDrawer);
      showFormStatus(form, 'Added to cart.');
    } catch (error) {
      showFormStatus(form, error.message || 'Unable to add this item.', true);
    } finally {
      if (submit) {
        submit.disabled = false;
        submit.textContent = originalLabel;
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.is-open[data-overlay-panel]').forEach(closePanel);
  });

  const initHeroSlider = (root) => {
    if (!root || root.dataset.kzHeroReady === 'true') return;
    const slides = Array.from(root.querySelectorAll('[data-kz-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-kz-hero-dot]'));
    const previous = root.querySelector('[data-kz-hero-prev]');
    const next = root.querySelector('[data-kz-hero-next]');
    if (slides.length < 1) return;

    root.dataset.kzHeroReady = 'true';
    let activeIndex = 0;
    let timer;
    const autoplaySeconds = Number(root.dataset.autoplaySeconds || 5);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const showSlide = (requestedIndex) => {
      activeIndex = (requestedIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        const link = slide.querySelector('a');
        if (link) link.tabIndex = isActive ? 0 : -1;
      });
      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
    };

    const stopAutoplay = () => window.clearInterval(timer);
    const startAutoplay = () => {
      stopAutoplay();
      if (slides.length > 1 && !reducedMotion) {
        timer = window.setInterval(() => showSlide(activeIndex + 1), autoplaySeconds * 1000);
      }
    };

    previous?.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      startAutoplay();
    });
    next?.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      startAutoplay();
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      showSlide(Number(dot.dataset.kzHeroDot));
      startAutoplay();
    }));
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
    });

    showSlide(0);
    startAutoplay();
  };

  const initHeroSliders = (scope = document) => {
    if (scope.matches?.('[data-kz-hero-slider]')) initHeroSlider(scope);
    scope.querySelectorAll?.('[data-kz-hero-slider]').forEach(initHeroSlider);
  };

  initHeroSliders();
  document.addEventListener('shopify:section:load', (event) => initHeroSliders(event.target));

  fetchCart().catch(() => {});
})();
